import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VeeVal } from "./VeeValidateHelper";
import VueScript2 from "vue-script2";
import VModal from "vue-js-modal";
import MaskedInput from "vue-text-mask";
import VueScrollTo from "vue-scrollto";
import VueGtag from "vue-gtag";

import MsalInstance from "./plugins/MsalInstance";
import AppConstants from "./plugins/AppConstants";

Vue.use(VeeVal);
Vue.use(VueScript2);
Vue.use(VModal);
Vue.use(MsalInstance);
Vue.use(AppConstants);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(
  VueGtag,
  {
    config: { id: "G-QR6G3HJENL" },
    enabled: process.env.NODE_ENV === "production" ? true : false
  },
  router
);

Vue.component("masked-input", MaskedInput);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
